// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

export const BASEURL = `https://cinemacity-uat-api.nuviotech.co`;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://cinemacity-uat-api.nuviotech.co`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const SALES_APP = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImVlZjc3YjI0LTA2M2MtNDAyMC1hNmZlLTJjNGY2MmYwYTEzZiIsImlhdCI6MTc4NjM1NzIwMH0.zud93Yr_n0rT8y7iCSWrZhciJ_4C-98iI3czdq2dGUg`
export const TOKEN = SALES_APP



// WEBPACK FOOTER //
// ./src/config/index.js